import { auth, cloudFunctionsAPI } from "../firebase";

/**
 * POST a JSON body to an onRequest Cloud Function as the signed-in user and
 * return the raw Response.
 *
 * For the streaming (SSE) endpoints, which are plain HTTP rather than
 * callables: pair it with utils/readSSEStream. Status handling stays with the
 * caller, because each endpoint reports failures differently (some send a JSON
 * `error`, some only a status code).
 */
export const fetchFunction = async (name, body) => {
  const token = await auth.currentUser.getIdToken();
  const url = cloudFunctionsAPI.getUrl(name, cloudFunctionsAPI.locationID);
  return fetch(url, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
};
